<template>
    <VDatePicker 
        borderless
        v-model="date" 
        mode="date" 
        @click="selectDate(date)"
        locale="en-US"
        :rules="rules"
        :attributes="attrs"
        :timezone="timezone"
        :min-date="minDate"
        :week-start="1"
        :disabled-week-days="[3, 4, 5, 6, 0]"
    />
    <div class="btn-row">
        <div class="btn save-delivery-date" @click="setDeliveryDate(date)">Save new delivery date</div>
    </div>
</template>

<script>

import { ref } from 'vue';

export default {
    name: 'calenderApp',
    props: ['order'],
    components: {
    },
    data() {
        return {
            date: '',
            timezone: ref('Europe/Dublin'),
            rules: ref(
                {
                    hours: 13,
                    minutes: 0,
                    seconds: 0,
                    milliseconds: 0,
                },
            ),
            attrs: ref([
                //{
                //     key: 'monday-highlight',
                //     highlight: {
                //         backgroundColor: '#ddd', // Customize your highlight color
                //         borderRadius: '50%',
                //     },
                //     dates: new Date(), // 2 corresponds to Monday (1 is Sunday)
                // },
                // {
                //     key: 'monday-disable',
                //     customData: { isDisabled: false },
                //     dates: { excludeMode: true, weekdays: [2] }, // 2 corresponds to Monday (1 is Sunday)
                // },
                // {
                //     key: 'disable-all',
                //     customData: { isDisabled: true },
                //     dates: { excludeMode: false, weekdays: [0, 1, 3, 4, 5, 6] }, // Exclude all days except Monday
                // },
            ])
        }
    },
    computed: { 
        minDate() {
            let date = new Date();
            return date.setDate(date.getDate() + 1);
        },
        viewCalendar() {
            return this.$store.getters.calendar ?? false;
        },
        lastOrder() {
            return this.$store.getters.lastOrder;
        },  
    },
    emits: ['update:visible'],
    methods: {
        selectDate(date) {
            
            const today = new Date();
            const day = new Date(date);
           
            if ( date <= today || day.getDay() != 1 ) {
                this.$store.commit('setAlertData', { title: 'Error', text: 'Invalid date', type: 'error', visible: true });
            }
        },
        setDeliveryDate(date) { 
            const today = new Date();
            if ( date >= today && date.getDay() === 1 ) {
                this.$emit('update:visible', false);
                this.$store.dispatch('updatePlanDetails', { ID: this.order.order_id, data: {delivery_date: date }});
                this.date = '';
            } else {
                this.$store.commit('setAlertData', { title: 'Error', text: 'Invalid date', type: 'error', visible: true });
            }
        },
    },
    async beforeMount() {
        this.date = this.order.strtotime;
    },
    watch: {
        
    }
}
</script>
<style lang="stylus">
.vc-bordered {
    border: none!important;
}

.vc-title {
    font-weight: 500;
    font-size: 20px!important;
    color: #1D2433;
    font-family: 'Manrope', sans-serif;  
    text-transform: capitalize;
}

.vc-highlight-bg-solid {
    background: none!important;
}

.vc-day-content {
    font-weight: 500;
    font-size: 20px!important;
    color: #ccc;
    font-family: 'Manrope', sans-serif;
    width: 40px!important;
    min-height: 40px!important;

    &.vc-blue {
        color: #1D2433;
        border: 2px solid #2AD2C9;
        border-radius: 50%;
        background-color: #2AD2C933!important;
    }
}

.vc-light .vc-day.weekday-2 .vc-day-content.vc-attr:not(.vc-disabled) {
    color: #1D2433;
    border: 2px solid #685BC7;
    border-radius: 50%;
    background-color: rgba(104, 91, 199, .2);

    &.vc-blue {
        color: #1D2433;
        border: 2px solid #2AD2C9;
        border-radius: 50%;
        background-color: #2AD2C933!important;
    }
}

.vc-light .vc-day {
    &.weekday-1,
    &.weekday-2,
    &.weekday-3,
    &.weekday-4,
    &.weekday-5,
    &.weekday-6,
    &.weekday-7 {
        border: none!important;

        .vc-day-content.vc-disabled {
            color: #ccc!important;
            border: none!important;
            border-radius: 50%;
            background-color: #fff!important;
            cursor: not-allowed!important;

            &.vc-blue {
                color: #ccc!important;
                border: none!important;
                border-radius: 50%;
                background-color: #fff!important;
                cursor: not-allowed!important;
            }

            &.vc-focus:focus-within {
                box-shadow: none!important;
            }
        }
    }

}

.vc-light .vc-day {
    &.weekday-1,
    &.weekday-3,
    &.weekday-4,
    &.weekday-5,
    &.weekday-6,
    &.weekday-7 {
        border: none!important;

        .vc-day-content {
            color: #ccc!important;
            border: none!important;
            border-radius: 50%;
            background-color: #fff!important;
            cursor: not-allowed!important;

            &.vc-blue {
                color: #ccc!important;
                border: none!important;
                border-radius: 50%;
                background-color: #fff!important;
                cursor: not-allowed!important;
            }

            &.vc-highlight-content-solid {
                font-weight: 400!important;
            }

            &.vc-focus:focus-within {
                box-shadow: none!important;
                font-weight: unset!important;
            }
        }
    }

}

.popup-calendar {
    max-width: 600px;
    .v-overlay__content {
        border-radius: 10px;
        overflow: hidden;
    }
    .v-card {
        @media screen and (max-width: 550px) {
            padding-left: 0!important;
            padding-right: 0!important;
            padding-top: 0!important;
        }
    }
    .v-card-actions  {
        .v-btn__content {
            flex-direction: column;
            transform: scale(.6);
            letter-spacing: 0;
            transition-duration: .4s;

            &:hover {
                color: #fff;
                fill: #fff!important;

                path {
                    fill: #fff!important;
                }
            }
        }
        button {
            display: flex 
            padding-top: 5px
            &:hover .v-btn__content {
                color: #fff;
                fill: #fff!important;
                @media screen and (max-width: 767px) {
                    fill: #685bc7!important;
                    color: #685bc7;
                }

                path {
                    fill: #fff!important;
                    
                    @media screen and (max-width: 767px) {
                        fill: #685bc7!important;
                    }
                }
            }
            @media screen and (max-width: 550px) {
                padding-right: 0!important;
                max-width: 45px;
                min-width: 0;
                
            }
            .v-ripple__container,
            .v-btn__overlay, .v-btn__underlay {
                @media screen and (max-width: 767px) {
                    display: none!important;
                }
            }
            &.focus,
            &:hover,
            &:active {
                 @media screen and (max-width: 767px) {
                    background: none!important;
                }
                .v-btn__overlay {
                    @media screen and (max-width: 767px) {
                        background: none!important;
                        displa
                    }
                }
            }
        }        
    }
}

</style>
